<template>
 <div>
  <div class="w-100 text-center" style="margin-top: -30px">
    <!-- style="position: absolute; top: 20px; left: 47%" -->
    <img src="@/assets/images/ability_test/page_number3.png" alt="" >
  </div>
  <b-row class="pt-3">
    <b-col md="2"></b-col>
    <b-col md="8">
      <h4 class="text-center text-light font-weight-light px-5 mb-3">If you won an Oscar for your life so far, would it be more likely to be for...?</h4>
    </b-col>
    <b-col md="2"></b-col>
  </b-row>
  <b-row class="w-100 banner py-5">
    <b-col md="2"></b-col>
    <b-col md="1"></b-col>
    <b-col md="2"> 
      <div :class="answer == 'best_actor' ? 'text-center cursor-pointer selected' : 'text-center cursor-pointer'" @click="select('best_actor')">
        <img src="@/assets/images/ability_test/fram1.png" alt="" width="100%">
      </div>
    </b-col>
    <b-col md="2"> 
      <div :class="answer == 'best_cinema' ? 'text-center cursor-pointer selected' : 'text-center cursor-pointer'" @click="select('best_cinema')">
        <img src="@/assets/images/ability_test/fram2.png" alt="" width="100%">
      </div>
    </b-col>
    <b-col md="2"> 
      <div :class="answer == 'best_supporting' ? 'text-center cursor-pointer selected' : 'text-center cursor-pointer'" @click="select('best_supporting')">
        <img src="@/assets/images/ability_test/fram3.png" alt="" width="100%">
      </div>
    </b-col>
    <b-col md="1"></b-col>
    <b-col md="2"> </b-col>
  </b-row>
 </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BRow, 
  BCol, 
  BLink, 
  BButton, 
  BForm, 
  BFormCheckbox, 
  BFormGroup, 
  BFormInput, 
  BInputGroup, 
  BInputGroupAppend, 
  BImg, 
  BCardTitle, 
  BCardText,
} from 'bootstrap-vue'

export default {
  components: {
    BRow,
    BImg,
    BCol,
    BLink,
    BButton,
    BForm,
    BCardText,
    BCardTitle,
    BFormCheckbox,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    // validations
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      answer: null
    }
  },
  computed: {
  },
  methods: {
    select(data){
      this.answer = data
    }
  },
}
/* eslint-disable global-require */
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@100..900&display=swap');
</style>
<style scoped>
.banner{
  background: url('../../../assets/images/ability_test/banner.png');
}
.selected{
  border: 5px solid #E84185 !important;
  border-radius: 15px;
  box-shadow: 0 1rem 3rem #E84185 !important;
  /* box-shadow: #E84185 ; */
}
</style>
